module.exports = __webpack_public_path__ + "static/media/ai.22727512.svg";